import React, { useRef, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@stone/utils/analytics';
import { debounce } from '@utils/functions';
import { useDispatch, useSelector } from 'react-redux';
import { SearchActionTypes } from '@state/features/common.types';
const SearchField = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { inputSearch } = useSelector((state) => state.search);
    const isLoading = useSelector((state) => state.loading).requests.includes('SEARCH');
    const { minSearchChars } = props.searchData;
    const inputRef = useRef(null);
    const inputFirstEdit = useRef(true);
    const searchFormRef = useRef(null);
    // per gestire il loading async
    const [localLoading, setLocalLoading] = useState(false);
    useEffect(() => {
        if (!isLoading) {
            setLocalLoading(false);
        }
    }, [isLoading]);
    const updateInputSearch = (search) => {
        if (inputFirstEdit.current && search.length > 0) {
            analytics.search('search start');
            inputFirstEdit.current = false;
        }
        dispatch({
            type: SearchActionTypes.INPUT_SEARCH,
            payload: search,
        });
    };
    // TODO for clean code should be moved inside saga
    // debounced search from input
    const startSearch = useCallback(debounce(() => {
        dispatch({
            type: SearchActionTypes.FETCH_SEARCH,
            payload: {
                resultsType: 'REFINE',
            },
        });
        dispatch({
            type: SearchActionTypes.QUERY_SEARCH,
        });
    }, props.searchData.searchDebounceTimeout || 500), []);
    return (React.createElement("div", { className: "search-dialog__form" },
        React.createElement("form", { ref: searchFormRef, className: "search-modal__form", role: "search" },
            React.createElement("div", { className: "form-group" },
                React.createElement("div", { className: "form-control" },
                    React.createElement("label", { className: "font__title", htmlFor: "searchLabel" }, t('search.dialog.inputlabel')),
                    React.createElement("input", { ref: inputRef, type: "search", name: "searchLabel", id: "searchLabel", autoComplete: "off", placeholder: t('search.placeholder'), "aria-label": t('search.placeholder'), 
                        // aria-controls={!noResult && inputSearch?.length >= minSearchChars ? 'searchResults' : null}
                        value: inputSearch, onChange: (e) => {
                            updateInputSearch(e.currentTarget.value);
                            if (e.currentTarget.value != '' && e.currentTarget.value.length >= parseInt(minSearchChars)) {
                                startSearch();
                                setLocalLoading(true);
                            }
                            else {
                                dispatch({
                                    type: SearchActionTypes.UPDATE_SEARCH_REFINEMENT,
                                    payload: {
                                        filterAction: 'RESET',
                                    },
                                });
                            }
                        }, onKeyDown: (e) => {
                            if (e.key == 'Enter')
                                e.preventDefault();
                        }, onKeyUp: (keyboardEvent) => {
                            if (keyboardEvent.code === 'Enter' || keyboardEvent.key === 'Enter') {
                                keyboardEvent.currentTarget.blur();
                            }
                        } }),
                    React.createElement("div", { className: "search-modal__ctas" },
                        localLoading && React.createElement("span", null, t('search.results.loadingm')),
                        !!(inputSearch === null || inputSearch === void 0 ? void 0 : inputSearch.length) && inputRef && (React.createElement("button", { type: "button", className: "form-control__reset-button font__cta", "aria-label": t('button.resetinput'), onClick: (e) => {
                                e.preventDefault();
                                inputRef.current.value = null;
                                inputRef.current.focus();
                                inputFirstEdit.current = true;
                                dispatch({
                                    type: SearchActionTypes.RESET_SEARCH,
                                });
                            } }, t('button.clear')))))),
            React.createElement("input", { type: "submit", hidden: true }))));
};
export default SearchField;
